var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshicon = function SvgRefreshicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 8a7.2 7.2 0 0 1-7.2 7.2 7.111 7.111 0 0 1-4.128-1.304.4.4 0 0 1-.056-.608l.576-.584a.4.4 0 0 1 .504-.048A5.527 5.527 0 0 0 9.8 13.6 5.6 5.6 0 1 0 4.2 8h1.888a.392.392 0 0 1 .288.12l.16.16a.4.4 0 0 1 0 .568L3.712 11.68a.408.408 0 0 1-.568 0L.32 8.848a.4.4 0 0 1 0-.568l.16-.16A.392.392 0 0 1 .768 8H2.6A7.2 7.2 0 0 1 17 8Z"
  })));
};
export default SvgRefreshicon;